"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var _themeGet = require("@styled-system/theme-get");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _Box = require("../Box");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var textDecoration = (0, _styledSystem.system)({
  textDecoration: true
});
var linkMixin = (0, _styledSystem.compose)(_Box.boxMixin, textDecoration);

/**
 * Basic <a> tag styled with additional LinkProps
 *
 * Tip: If working on Force, please use <Link as={RouterLink}>.

 */
var Link = _styledComponents.default.a.withConfig({
  displayName: "Link",
  componentId: "sc-oxrwcw-0"
})(["color:currentColor;transition:color 0.25s;&:hover{color:", ";}&:visited{color:", ";}", ";"], (0, _themeGet.themeGet)("colors.blue100"), (0, _themeGet.themeGet)("colors.blue150"), linkMixin);
exports.Link = Link;
Link.displayName = "Link";
Link.defaultProps = {
  textDecoration: "underline"
};
//# sourceMappingURL=Link.js.map